import React, {useState, useContext} from 'react';
import styled from 'styled-components';
import {OverlayContext} from '../contexts/OverlayContext';

import {OzButton, OzCard, OzInput, OzCheckbox, OzCol, OzRow} from '@ozwol/webui';

import ModalWebhook2 from './ModalWebhook2';
import WebhookWizard from './WebhookWizard';

import CardHeaderTitle from '../components/CardHeaderTitle';

import {isValidHttpUrl} from '../helpers';

const Container = styled.div`
  width: 450px;
`;


const ModalWebhook1 = ({item, projects, onSuccess}) => {
  const {replaceOverlay, removeOverlay} = useContext(OverlayContext);
  const [currentItem, setCurrentItem] = useState({
		...item, 
		endpoint: !item ? "https://": item.endpoint,
		active: !item ? true: item.active
	});

  return (
    <Container>

      <OzCard
        headerLeft={
          <CardHeaderTitle 
            title={"Endpoint"} 
          />
        }
        headerSeparator={true}
        footerLeft={<OzButton variant={"chetwodeblue-o"} onClick={() => removeOverlay("webhook")}>Cancel</OzButton>}
        footerRight={<OzButton disabled={!currentItem || !currentItem.endpoint || !isValidHttpUrl(currentItem.endpoint)} variant={"chetwodeblue-o"} onClick={() => 
					replaceOverlay({
						reference: "webhook",
						content: <ModalWebhook2 
							item={currentItem} 
							projects={projects}
							onSuccess={onSuccess}
						/>,
						isCloseable: false
					}, "webhook")
				}>Next</OzButton>}
      >
        {/* xxx

        <br/> */}
				<OzRow>
					<OzCol widthmd="12">
						<OzInput
							label="Endpoint"
							width="100%"
							value={currentItem && currentItem.endpoint ? currentItem.endpoint : ""}
							onChange={(val) => {
								let tempItem = {...currentItem};
								tempItem.endpoint = val;
								setCurrentItem(tempItem);
							}}
							required
						/>
					</OzCol>
					<OzCol widthmd="12">
						<OzInput
							label="Description"
							width="100%"
							value={currentItem && currentItem.description ? currentItem.description : ""}
							onChange={(val) => {
								let tempItem = {...currentItem};
								tempItem.description = val;
								setCurrentItem(tempItem);
							}}
						/>
					</OzCol>
					<OzCol widthmd="12">
						<OzCheckbox
							label="Active"
							selected={currentItem && currentItem.active ? currentItem.active : false}
							onChange={(val) => {
								let tempItem = {...currentItem};
								tempItem.active = val;
								setCurrentItem(tempItem);
							}}
						/>
					</OzCol>
				</OzRow>

        <br/>
        <WebhookWizard step={1} />

      </OzCard>

    </Container>
  );

}

export default ModalWebhook1;
